import { AfterViewInit, Directive, ElementRef, Input, OnChanges, Renderer2 } from '@angular/core';

@Directive({
	selector: 'mat-tab-group[goTablistAria]'
})
export class FeedbackPanelTablistAriaDirective implements AfterViewInit, OnChanges {
	@Input() public goTablistAriaLabel: string | null = null;
	@Input() public goTablistAriaOrientation: 'horizontal' | 'vertical' | null = null;

	constructor (
		private elementRef: ElementRef<HTMLElement>,
		private renderer: Renderer2
	) {}

	public ngAfterViewInit (): void {
		this.applyAttributes();
	}

	public ngOnChanges (): void {
		this.applyAttributes();
	}

	private applyAttributes (): void {
		const tablist: HTMLElement = this.elementRef.nativeElement.querySelector('[role="tablist"]');

		this.renderer.setAttribute(tablist, 'aria-label', this.goTablistAriaLabel);
		this.renderer.setAttribute(tablist, 'aria-orientation', this.goTablistAriaOrientation);
	}
}
